import { deserializeArray } from 'class-transformer';
import { apiService } from './api';
import { Money, Order } from '../dto';
import { Currency } from '../common/enums';
import { PaginationLinks, PaginationMeta } from '../types';

export interface PaginatedOrders {
  links: PaginationLinks;
  meta: PaginationMeta;
  orders: Order[];
}

interface GetPaginatedOrdersInput {
  page: number;
  search?: string;
}

export async function getPaginatedOrders(input: GetPaginatedOrdersInput): Promise<PaginatedOrders> {
  const path = `/orders`;
  const page = input.page || 1;
  const search = input.search || null;

  const { data } = await apiService({
    method: 'get',
    path,
    params: { page, keyword: search },
  });

  if (data?.data) {
    const { links, meta } = data.data;
    const orders = data?.data?.resources.map(parseOrder);
    return { links, meta, orders: deserializeArray(Order, JSON.stringify(orders)) };
  }
  throw new Error('getPaginatedOrders failed');
}

// TODO: move to util function and update Money DTO
export function getShippingFee(input: Record<string, any>): Money {
  const { amount, currency, minor } = input;
  const value = amount / 10 ** minor;
  return new Money({ value, currency: Currency[currency as keyof typeof Currency] });
}

const parseOrder = (input: any) => {
  const shipment = input?.shipments[0];
  const logisticProvider = shipment?.carrierService?.carrier;
  const logisticServiceCode = shipment?.carrierService?.slug;
  return {
    ...input,
    id: input.ref,
    boxes: shipment.boxes,
    logisticProvider,
    logisticServiceCode,
    fromAddress: shipment.fromAddress,
    toAddress: shipment.toAddress,
    metadata: shipment.metadata,
    totalPackages: shipment.totalBox,
    totalWeight: shipment.totalWeight,
    trackingNumber: shipment.trackingNumber,
    finalTotal: getShippingFee(input.finalTotal),
  };
};
